import React from 'react'
import Hero from '../components/Home/Hero'
import Introduction from '../components/Home/Introduction'
import Amenities from '../components/Home/Amenities'
import InstagramConnect from '../components/Home/InstagramConnect'
import Footer from '../components/Home/Footer'
import Reviews from '../components/Home/Reviews'
import GrandOpening from '../components/Shared/GrandOpening'
import ImageSlider from '../components/Shared/ImageSlider'

const Home = () => {
  return (
    <div className='px-3 pb-3 bg-[#fafafa]'>
      <GrandOpening />
      <Hero />
      <Introduction />
      <ImageSlider />
      <Amenities />
      <Reviews />
      <InstagramConnect />
      <Footer />
    </div>
  )
}

export default Home